import { render } from "./Monogram.vue?vue&type=template&id=fb4bb504"
import script from "./Monogram.vue?vue&type=script&lang=js"
export * from "./Monogram.vue?vue&type=script&lang=js"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__